import { NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

interface FilterGroupSkeleton {
  labelWidth: string;
  optionLabelWidths: string[];
}

@Component({
  selector: 'app-unit-route-loading-skeleton',
  standalone: true,
  imports: [NgTemplateOutlet, SkeletonModule],
  templateUrl: './unit-route-loading-skeleton.component.html',
  styleUrl: './unit-route-loading-skeleton.component.scss',
})
export class UnitRouteLoadingSkeletonComponent {
  readonly headerActions = [0, 1];
  readonly filterGroups: FilterGroupSkeleton[] = [
    { labelWidth: '45%', optionLabelWidths: ['70%', '55%', '70%', '55%'] },
    { labelWidth: '50%', optionLabelWidths: ['60%', '72%', '60%'] },
  ];
  readonly categoryIndices = [0, 1];
  readonly productCardIndices = [0, 1, 2, 3];
}
